import * as token from "app/localStorage/token"
import axios, { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from "axios"
import { getAccessToken } from "../localStorage/token"
import { authorize, refresh } from "./oauth"

export function requestInterceptor(config: InternalAxiosRequestConfig) {
  const newConfig = config
  const accessToken = getAccessToken()
  if (accessToken) newConfig.headers.Authorization = `Bearer ${accessToken}`
  return newConfig
}

export function responseInterceptor(response: AxiosResponse) {
  return response
}

export function responseErrorInterceptor(error: AxiosError) {
  if (error && error.response && error.response.status === 401) {
    return refreshToken(error)
  }
  return Promise.reject(error)
}

function refreshToken(requestError: AxiosError) {
  return refresh()
    .then(newToken => {
      token.storeAccessToken(newToken && newToken.accessToken)
      token.storeIdToken(newToken && newToken.idToken)
      const { config } = requestError
      if (!config) return Promise.reject(requestError)
      config.headers.Authorization = `Bearer ${newToken.accessToken}`
      return new Promise((resolve, reject) => {
        axios
          .request(config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    })
    .catch(
      e =>
        new Promise((resolve, reject) => {
          reject(e)
          authorize()
        }),
    )
}
